import { cx } from "@/utils";

import styles from "../Modal.module.css";

const ModalHeader: React.FunctionComponent<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return (
    <div className={cx(styles.header, styles.padding, className)}>
      {children}
    </div>
  );
};

export default ModalHeader;
